import Select from 'react-select';

const CustomSelection = (props) => {

    const {
        datalist,
        fieldid,
        SelectionChange,
        isdisable,
        isactivedisable,
        issearchable,
        isclearable,
        selId,
        selRef,
        placeholder,
        isMulti = false,
        inputId = ""
    } = props
    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: (state.isDisabled && isactivedisable) ? "red" : state.isFocused ? "#0777A9" : "#ced4da",
            boxShadow: (state.isDisabled && isactivedisable) ? "none" : state.isFocused ? "0 0 0 0.2rem rgba(40, 142, 167, 0.25) !important" : "#ced4da",

            "&:hover": {
                borderColor: "none",
                boxShadow: "none"
            },
            "&:focus": {
                borderColor: "#0777A9 !important",
                boxShadow: "0 0 0 0.2rem rgba(40, 142, 167, 0.25) !important"
            }

        })
    };
    const onchange = (e) => {
        SelectionChange(e)
    }
    return (
        // <>
        <Select
            inputId={inputId}
            ref={selRef}
            isMulti={isMulti}
            className="dropdown select_dropdown"
            options={datalist}
            value={datalist?.filter(function (datalist) {
                return datalist.value === fieldid;
            })}// set list of the data
            onChange={onchange} // assign onChange function
            // isDisabled={(isdisable) ? true : false}
            isDisabled={(isdisable || isactivedisable) ? true : false}
            isSearchable={issearchable}
            styles={customStyles}
            isClearable={isclearable}
            placeholder={placeholder}
        />
        // </>
    );
}
export default CustomSelection;